/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type TerminateJobRequest = {
  id: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

export type TerminateJobResponse =
  | components.ComputeJob
  | components.ComputeErrorEnvelope;

/** @internal */
export const TerminateJobRequest$inboundSchema: z.ZodType<
  TerminateJobRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type TerminateJobRequest$Outbound = {
  id: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const TerminateJobRequest$outboundSchema: z.ZodType<
  TerminateJobRequest$Outbound,
  z.ZodTypeDef,
  TerminateJobRequest
> = z.object({
  id: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function terminateJobRequestToJSON(
  terminateJobRequest: TerminateJobRequest,
): string {
  return JSON.stringify(
    TerminateJobRequest$outboundSchema.parse(terminateJobRequest),
  );
}
export function terminateJobRequestFromJSON(
  jsonString: string,
): SafeParseResult<TerminateJobRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TerminateJobRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TerminateJobRequest' from JSON`,
  );
}

/** @internal */
export const TerminateJobResponse$inboundSchema: z.ZodType<
  TerminateJobResponse,
  z.ZodTypeDef,
  unknown
> = z.union([
  components.ComputeJob$inboundSchema,
  components.ComputeErrorEnvelope$inboundSchema,
]);
/** @internal */
export type TerminateJobResponse$Outbound =
  | components.ComputeJob$Outbound
  | components.ComputeErrorEnvelope$Outbound;

/** @internal */
export const TerminateJobResponse$outboundSchema: z.ZodType<
  TerminateJobResponse$Outbound,
  z.ZodTypeDef,
  TerminateJobResponse
> = z.union([
  components.ComputeJob$outboundSchema,
  components.ComputeErrorEnvelope$outboundSchema,
]);

export function terminateJobResponseToJSON(
  terminateJobResponse: TerminateJobResponse,
): string {
  return JSON.stringify(
    TerminateJobResponse$outboundSchema.parse(terminateJobResponse),
  );
}
export function terminateJobResponseFromJSON(
  jsonString: string,
): SafeParseResult<TerminateJobResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TerminateJobResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TerminateJobResponse' from JSON`,
  );
}
